import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  topBar: {
    display: 'flex',
    alignItems: 'center',
    padding: [theme.spacing(2), 0],
    borderBottom: [1, 'solid', theme.palette.colors.border],
  },
  rows: {
    display: 'flex',
    alignItems: 'center',
    height: 40,
    borderRight: [1, 'solid', theme.palette.colors.divider],
  },
  rowsCount: {
    margin: [0, theme.spacing(2)],
  },
  approveButton: {
    marginLeft: theme.spacing(2),
    height: 40,
    fontSize: 12,
    [theme.breakpoints.up('mobile')]: {
      fontSize: 'unset',
    },
  },
  container: {
    width: '100%',
    height: '50%',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'auto',
    [theme.breakpoints.up('mobile')]: {
      height: 'unset',
      flexGrow: 1,
    },
    paddingBottom: 20,
  },
  loaderBox: {
    width: '100%',
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  skeletonBox: {
    height: 110,
    padding: [0, theme.spacing(2)],
    [theme.breakpoints.up('mobile')]: {
      padding: [0, theme.spacing(4)],
    },
    borderBottom: [1, 'solid', theme.palette.colors.divider],
    display: 'flex',
    alignItems: 'center',
  },
  skeletonText: {
    width: '100%',
    height: 50,
    borderRadius: 8,
    marginLeft: theme.spacing(3),
  },
  emptyLabel: {
    display: 'flex',
    padding: [theme.spacing(1)],
    marginTop: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    backgroundColor: theme.palette.colors.warning,
  },
}));



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentLoanOfficers/components/WaitlistLoanOfficersList/useStyles.js